import * as React from "react";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

export class QuickerQuoteErrorPagePlain extends React.Component<IWithRouterProps> {

    private readonly pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Quicker Quote Error");
    }

    public render() {
        return (
            <React.Fragment>
                {this.pluginTemplates.renderHeader()}
                <div className="error-page">
                    <div className="main-plugin panel mb-6">
                        <h1 className="error-title">Something went wrong...</h1>
                        <h2 className="error-text">
                            To keep your details safe, we've ended your session due to inactivity.
                            This means we'll need to start again, so <a className="text-decoration-underline" href={"https://www.allianz.co.uk/insurance/car-insurance.html"}>click here to begin</a>.
                        </h2>
                    </div>
                </div>
                {this.pluginTemplates.renderFooter()}
            </React.Fragment>
        );
    }

}

export const QuickerQuoteErrorPage = withRouter(QuickerQuoteErrorPagePlain)
